module.exports = __webpack_public_path__ + "static/media/IMG-20230508-WA0176.165a5a74.jpg";